import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { heroMicrocopy, heroMockup } from '../data/content';
export function Hero() {
  return <header className="flex min-h-[calc(100svh-2.75rem)] w-full flex-col justify-center bg-cream px-5 py-6 sm:px-8 sm:py-8" data-id="element-109" data-mp="9lv1krql6hwd">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-110" data-mp="4n9wof0e3a1l">
        <Reveal data-id="element-111" data-mp="1285x3nzc5smb">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-level-blue sm:text-[11px]" data-id="element-112" data-mp="128pft6wt8l1e">
            Den kompletta innebandyläroplanen
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-113" data-mp="s9q7xqjvctfg">
          <h1 className="mt-3 text-[26px] font-extrabold leading-[1.08] tracking-tight text-navy sm:mt-4 sm:text-4xl md:text-5xl" data-id="element-114" data-mp="sd48ct8z2sk9">
            Undervisa ett helt läsår i{' '}
            <span className="font-serif italic font-normal text-level-blue" data-id="element-115" data-mp="3d2tpjcx5eqg4">
              Innebandy
            </span>{' '}
            på bara 5 minuters förberedelse
          </h1>
        </Reveal>

        <Reveal delay={0.12} data-id="element-116" data-mp="3j9afx9oryk3k">
          <p className="mx-auto mt-3 max-w-xl text-[13px] leading-snug text-muted sm:mt-4 sm:text-base sm:leading-relaxed" data-id="element-117" data-mp="3o7lv7zxu9mt6">
            Innebandy Ready är en komplett, färdig innebandyläroplan — 10 färdiga volymer
            fyllda med teknik, taktik, övningar och utvärderingar, för åldrarna 6–16 år.
            Bara skriv ut, öppna och undervisa.
          </p>
        </Reveal>

        <Reveal delay={0.18} className="w-full" data-id="element-118" data-mp="30g6mnpfgy99h">
          <img src={heroMockup} alt="Innebandy Ready-paketet: volym 1 till 10 i nivåerna Grön, Blå och Röd tillsammans med de fem bonusmaterialen, klubba, boll och taktiktavla" className="mx-auto mt-4 max-h-[30vh] w-full max-w-2xl object-contain sm:mt-6 sm:max-h-[34vh]" data-id="element-119" data-mp="359t03jtgih6c" />
        </Reveal>

        <Reveal delay={0.24} className="w-full max-w-md" data-id="element-120" data-mp="2hl9sz7m58afu">
          <div className="mt-5 w-full sm:mt-7" data-id="element-121" data-mp="2ljpbay7a4umx">
            <CtaButton className="!py-4 !text-sm sm:!py-5 sm:!text-base" data-id="element-122" data-mp="2lml9mnn1hlbw" />
          </div>
        </Reveal>

        <Reveal delay={0.28} data-id="element-123" data-mp="s3umzlkswo5c">
          <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[11px] font-semibold text-muted sm:mt-4 sm:text-sm" data-id="element-124" data-mp="nb1ld6kmpvxh">
            {heroMicrocopy.map(item => <li key={item} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-125" data-mp="ddne9xklijhu">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-level-green sm:h-4 sm:w-4" aria-hidden="true" data-id="element-126" data-mp="1b0nilohfy12u" />
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </header>;
}